import { render, staticRenderFns } from "./import-history.vue?vue&type=template&id=30888b0b&scoped=true"
import script from "./import-history.vue?vue&type=script&lang=js"
export * from "./import-history.vue?vue&type=script&lang=js"
import style0 from "./import-history.vue?vue&type=style&index=0&id=30888b0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30888b0b",
  null
  
)

export default component.exports